//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function createTagService(name) {
    try {
        if (!name.trim()) {
            toast.warn("Digite um nome para a nova tag");
            return false;
        }
        await api.post("/tags", { nome: name });
        toast.success("Tag criada com sucesso");
        return true;
    } catch {
        toast.error("Erro ao criar tag");
        return false;
    }
}